  import { CartAddEvent } from '@theme/events';

  if (!window._magonQuickInit) {
    window._magonQuickInit = true;

    const closeAll = (except) => {
      document.querySelectorAll('.magon-card.is-quick-open').forEach((c) => {
        if (c === except) return;
        c.classList.remove('is-quick-open');
        const t = c.querySelector('.magon-card__quick-trigger');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    };

    // --- 1. Quick-buy trigger (mobile) ---
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('.magon-card__quick-trigger');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        const card = trigger.closest('.magon-card');
        if (!card) return;
        const willOpen = !card.classList.contains('is-quick-open');
        closeAll(willOpen ? card : null);
        card.classList.toggle('is-quick-open', willOpen);
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        return;
      }
      if (!e.target.closest('.magon-card.is-quick-open')) closeAll(null);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAll(null);
    });

    // --- 2. Seleção de tamanho (single_option mode) ---
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.magon-quick__size-btn');
      if (!btn) return;
      e.preventDefault();
      const card = btn.closest('.magon-card');
      if (!card) return;
      const variantInput = card.querySelector('.magon-variant-id');
      const submitBtn = card.querySelector('.magon-quick-btn');
      if (!variantInput || !submitBtn) return;

      card.querySelectorAll('.magon-quick__size-btn').forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');

      variantInput.value = btn.dataset.variantId;
      submitBtn.disabled = false;
      submitBtn.textContent = 'Comprar Agora';
    });

    // --- 3. AJAX add-to-cart ---
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('.magon-quick-form');
      if (!form) return;
      e.preventDefault();

      const btn = form.querySelector('button[type="submit"]');
      const variantInput = form.querySelector('.magon-variant-id');
      const variantId = variantInput?.value;
      if (!variantId || !btn) return;

      const originalText = btn.textContent;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Adicionando...';

      try {
        const formData = new FormData(form);

        // Coleta sections pra refresh do drawer/header no mesmo request
        // (mesmo padrão do product-form.js nativo). Evita renderSection extra.
        const sectionIds = Array.from(document.querySelectorAll('cart-items-component, cart-icon-component'))
          .map((el) => el.dataset.sectionId)
          .filter(Boolean);
        if (sectionIds.length) formData.append('sections', sectionIds.join(','));

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { Accept: 'application/json' },
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Falha ao adicionar');

        btn.textContent = 'Adicionado!';

        // Dispara CartAddEvent com sections HTML:
        // - cart-items-component morfa a seção do drawer (inclui cross-sell e remove buttons)
        // - cart-drawer-component (auto-open) abre o dialog
        // Ambos rodam no mesmo tick → DOM morfado antes do paint.
        document.dispatchEvent(new CartAddEvent({}, String(variantId), {
          source: 'magon-item',
          itemCount: 1,
          productId: form.querySelector('input[name="id"]')?.dataset.productId || undefined,
          sections: data.sections,
        }));

        // Fecha o drawer mobile do quick-buy
        closeAll(null);

        setTimeout(() => {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          btn.textContent = originalText;
        }, 1500);
      } catch (err) {
        console.error('Magon quick-buy ATC:', err);
        btn.textContent = (err.message && err.message.length <= 30) ? err.message : 'Erro';
        setTimeout(() => {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          btn.textContent = originalText;
        }, 2500);
      }
    });
  }
